import { useContext } from 'react';
import { BaseAppWrapperContext } from '@core/components';

export const useBaseAppConfig = () => {
  const { config } = useContext(BaseAppWrapperContext);

  return config;
};
